import { wssProtocol } from "@/common/config"
import { TableHub } from "../common/tableHub"
import { Object, SimpleObject } from "../model/object"
import { TeltonikaRow } from "../model/teltonika"

export class TeltonikaRepository {
    watcher: TableHub<TeltonikaRow>

    constructor() {
        let wss = wssProtocol()
        this.watcher = new TableHub<TeltonikaRow>(`${wss}://${location.host}/api/ws/teltonika/{id}`)
    }

    async list():Promise<string[]> {
        return fetch('/api/schema/teltonika').then((response) => { 
            return response.json()
        });
    }
}